import forge from 'node-forge';
const privateKeyPem = import.meta.env.VITE_PRIVATE_KEY;

function decryptData(encryptedData, encryptedKey, iv) {
  try {
    
    // Converti la chiave privata PEM in oggetto node-forge
    const privateKey = forge.pki.privateKeyFromPem(privateKeyPem);
    
    // Decodifica i dati dal formato Base64
    const encryptedKeyBytes = forge.util.decode64(encryptedKey);
    const encryptedDataBytes = forge.util.decode64(encryptedData);
    const ivBytes = forge.util.decode64(iv);
    
    // Decrittografa la chiave AES con RSA-OAEP
    console.log("Decrittografo la chiave AES con RSA-OAEP...");
    const aesKey = privateKey.decrypt(encryptedKeyBytes, 'RSA-OAEP');
    console.log(`Chiave AES recuperata, lunghezza: ${aesKey.length} byte`);
    
    // Decrittografa i dati con AES-CBC
    console.log("Decrittografo i dati con AES-CBC...");
    const decipher = forge.cipher.createDecipher('AES-CBC', aesKey);
    decipher.start({ iv: ivBytes });
    decipher.update(forge.util.createBuffer(encryptedDataBytes));
    
    const success = decipher.finish();
    if (!success) {
      throw new Error('Errore nella decrittografia AES');
    }
    
    const decryptedText = decipher.output.toString('utf8');
    
    return decryptedText;
  } catch (error) {
    console.error('Errore durante la decrittografia:', error);
    console.error('Stack trace:', error.stack);
    return null;
  }
}

export default decryptData;